export function isNum() {}

/**
 * 日期格式化
 * @param {*} value
 * @returns
 */
export const arrangeDate = (value, format = 'MM-dd hh:mm') => {
  if (typeof value == 'string') {
    value = value.replace(/\-/g, '/')
  }
  const time = new Date(value).format(format)
  return time
}

/**
 * 获取帖子分享logo
 * @param {*} posting 帖子
 */
export const getPostShareImg = (posting) => {
  // 有图片
  if (posting.images && posting.images.length > 0) {
    const image = posting.images[0]
    return image.filePath && image.filePath.length > 0 ? image.filePath : 0
  } else if (posting.videos && posting.videos.length > 0) {
    const video = posting.videos[0]
    return video.coverPath && video.coverPath.length > 0 ? video.coverPath : 0
  }
  return 0
}

Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours(), //小时
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return fmt
}

// 节流
export const throttle = (func, delay = 1000) => {
  //距离上一次的执行时间
  let lastTime = 0
  //不能用箭头函数
  return function () {
    let context = this
    let args = arguments
    let now = new Date().getTime()
    //如果距离上一次执行超过了delay才能再次执行
    if (now - lastTime > delay) {
      func.apply(context, args)
      lastTime = now
    }
  }
}

export function copyTextToClipboard(text) {
  var textarea = document.createElement('textarea')
  textarea.value = text
  // 将textarea元素添加到DOM中
  document.body.appendChild(textarea)
  // 选中textarea中的文本
  textarea.select()
  // 执行复制命令
  document.execCommand('copy')
  // 移除textarea元素
  document.body.removeChild(textarea)
}
